export var Navbar = function Navbar() {
  $('header').removeAttribute('style');

  // Reasonable defaults
  var PIXEL_STEP = 10;
  var LINE_HEIGHT = 40;
  var PAGE_HEIGHT = 800;
  function normalizeWheel(/*object*/event) /*object*/{
    var sX = 0,
      sY = 0,
      // spinX, spinY
      pX = 0,
      pY = 0; // pixelX, pixelY

    // Legacy
    if ('detail' in event) {
      sY = event.detail;
    }
    if ('wheelDelta' in event) {
      sY = -event.wheelDelta / 120;
    }
    if ('wheelDeltaY' in event) {
      sY = -event.wheelDeltaY / 120;
    }
    if ('wheelDeltaX' in event) {
      sX = -event.wheelDeltaX / 120;
    }

    // side scrolling on FF with DOMMouseScroll
    if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }
    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;
    if ('deltaY' in event) {
      pY = event.deltaY;
    }
    if ('deltaX' in event) {
      pX = event.deltaX;
    }
    if ((pX || pY) && event.deltaMode) {
      if (event.deltaMode == 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    }

    // Fall-back if spin cannot be determined
    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }
    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }
    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }
  var oldScrollY = 0;
  window.onscroll = function (e) {
    if (this.oldScroll > this.scrollY || this.scrollY === 0 && !$('.menu').classList.contains('active')) {
      $('header').classList.remove('hide');
    } else {
      $('header').classList.add('hide');
    }

    // console.log(this.oldScroll > this.scrollY);

    this.oldScroll = this.scrollY;
  };
};
export function Sections() {
  var sectionArr = [];
  if ($('.nav__sec')) {
    $('.nav__sec').classList.remove('active');
    $('.nav__sec').innerHTML = "";
  }
  setTimeout(function () {
    var div = document.createElement('div');
    div.classList.add('nav__sec');
    document.body.appendChild(div);
    $$('section').forEach(function (elem, index) {
      // if(elem.querySelector('.__title')) {
      elem.id = "section-".concat(index);
      var obj = {};
      obj.name = elem.querySelector('.__title') !== null ? elem.querySelector('.__title').textContent : "C\u0435\u043A\u0446\u0438\u044F ".concat(index + 1);
      obj.id = index;
      sectionArr.push(obj);
      // }
    });

    // console.log($('.hero').classList.contains('hidden'));

    sectionArr.forEach(function (item) {
      var url = "";
      if (window.location.pathname !== '/') url = window.location.pathname;

      // if(window.location)

      var tpl = "<a draggable=\"false\" class=\"nav__sec__item\" title=\"".concat(item.name, "\" href=\"").concat(url, "#section-").concat(item.id, "\">").concat(item.id + 1, "</a>");
      if (item.id === 0) tpl = "<a draggable=\"false\" class=\"nav__sec__item active\" title=\"".concat(item.name, "\" href=\"").concat(url, "#section-").concat(item.id, "\">").concat(item.id + 1, "</a>");
      $('.nav__sec').innerHTML += tpl;
    });
    if (sectionArr.length > 2) $('.nav__sec').classList.add('active');
    if ($('.hero') && $('.hero').classList.contains('hidden')) $$('.nav__sec__item')[0].classList.add('hidden');

    // console.log($$('.nav__sec__item')[0],$('.hero') && $('.hero').classList.contains('hidden'));
  }, 100);
}